export class AppConfig {
    public environment: string = "";
    public tenantId : string= "";
    public clientId: string = "";
    public baseUrl: string = "";
    public apiUrl: string = "";
    public sentry_engine_re: string = "";
    public sentry_mfg_re: string = "";
}